import { FoodStockRepository } from '../repositories/FoodStockRepository'

export function ListAllPatientsFoodStockCase(
  foodStockRepository: FoodStockRepository
) {
  return async function () {
    return await foodStockRepository.listAllPatientsFoodStock()
  }
}
